import styled from 'styled-components';

export const Title = styled.div`
    font-size: 20px;
    font-weight: bold;
`;
